<template>
<div class="chapter">
<div class="inner_page">
<p class="pn" id="pt1"><span class="epub-b">PART ONE</span></p>
<p class="pep-bot"><span class="epub-i">To reign is worth ambition though in hell: Better to reign in hell, than serve in heaven.</span></p>
<p class="pepc"><span class="epub-i">John Milton</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?147ac64f